module.exports = __webpack_public_path__ + "static/jumanji-logo-1ed6530b6e636119357edb1fcdda043a.png";